module.exports = __webpack_public_path__ + "assets/img/MoversBAIOS.ef7950b0.png";